import { IRIS_PERSONALIZED_CONTENT_REQUEST } from '../actionTypes/PersonalizedContentServiceActionTypes';

const getIrisPersonalizedContentService = (payload) => ({
    type: IRIS_PERSONALIZED_CONTENT_REQUEST,
    payload,
});

export default {
    getIrisPersonalizedContentService,
};
